module.exports = __webpack_public_path__ + "img/interface-1_jp.c9fd9d0.jpg";